// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mapbox Popup Styles for Imported File Info */
.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-content {
  background: rgba(40, 40, 40, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  backdrop-filter: blur(8px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  color: #fff;
  font-family: 'Louguiya', Arial, sans-serif;
  padding: 0;
  max-width: 300px;
}

.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-close-button {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  right: 8px;
  top: 8px;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 18px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}

.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-close-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #90caf9;
}

.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-tip {
  border-top-color: rgba(40, 40, 40, 0.95);
}

/* Popup content styles */
.imported-file-popup {
  padding: 16px;
  min-width: 250px;
}

.imported-file-popup .popup-header {
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 8px;
}

.imported-file-popup .popup-header h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #90caf9;
  font-family: 'Louguiya', Arial, sans-serif;
}

.imported-file-popup .layer-selector {
  width: 100%;
  padding: 4px 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #fff;
  font-family: 'Louguiya', Arial, sans-serif;
  font-size: 12px;
  outline: none;
  cursor: pointer;
}

.imported-file-popup .layer-selector:focus {
  border-color: #90caf9;
  background: rgba(255, 255, 255, 0.15);
}

.imported-file-popup .layer-selector option {
  background: #2a2a2a;
  color: #fff;
}

.imported-file-popup .popup-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.imported-file-popup .info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.imported-file-popup .info-row .label {
  font-weight: 500;
  color: #bdbdbd;
  font-size: 13px;
  min-width: 70px;
}

.imported-file-popup .info-row .value {
  font-weight: 600;
  color: #fff;
  font-size: 13px;
  text-align: right;
  flex: 1 1;
  margin-left: 12px;
  word-break: break-word;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .imported-file-popup {
    min-width: 200px;
    padding: 12px;
  }
  
  .imported-file-popup .popup-header h4 {
    font-size: 14px;
  }
  
  .imported-file-popup .info-row .label,
  .imported-file-popup .info-row .value {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MapboxPopup.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;EACzC,WAAW;EACX,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAO;EACP,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Mapbox Popup Styles for Imported File Info */\n.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-content {\n  background: rgba(40, 40, 40, 0.95);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  color: #fff;\n  font-family: 'Louguiya', Arial, sans-serif;\n  padding: 0;\n  max-width: 300px;\n}\n\n.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-close-button {\n  color: #fff;\n  font-size: 18px;\n  font-weight: bold;\n  right: 8px;\n  top: 8px;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 18px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  border: none;\n  cursor: pointer;\n}\n\n.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-close-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: #90caf9;\n}\n\n.mapboxgl-popup.imported-file-info-popup .mapboxgl-popup-tip {\n  border-top-color: rgba(40, 40, 40, 0.95);\n}\n\n/* Popup content styles */\n.imported-file-popup {\n  padding: 16px;\n  min-width: 250px;\n}\n\n.imported-file-popup .popup-header {\n  margin-bottom: 12px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding-bottom: 8px;\n}\n\n.imported-file-popup .popup-header h4 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #90caf9;\n  font-family: 'Louguiya', Arial, sans-serif;\n}\n\n.imported-file-popup .layer-selector {\n  width: 100%;\n  padding: 4px 8px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  color: #fff;\n  font-family: 'Louguiya', Arial, sans-serif;\n  font-size: 12px;\n  outline: none;\n  cursor: pointer;\n}\n\n.imported-file-popup .layer-selector:focus {\n  border-color: #90caf9;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.imported-file-popup .layer-selector option {\n  background: #2a2a2a;\n  color: #fff;\n}\n\n.imported-file-popup .popup-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.imported-file-popup .info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n}\n\n.imported-file-popup .info-row .label {\n  font-weight: 500;\n  color: #bdbdbd;\n  font-size: 13px;\n  min-width: 70px;\n}\n\n.imported-file-popup .info-row .value {\n  font-weight: 600;\n  color: #fff;\n  font-size: 13px;\n  text-align: right;\n  flex: 1;\n  margin-left: 12px;\n  word-break: break-word;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .imported-file-popup {\n    min-width: 200px;\n    padding: 12px;\n  }\n  \n  .imported-file-popup .popup-header h4 {\n    font-size: 14px;\n  }\n  \n  .imported-file-popup .info-row .label,\n  .imported-file-popup .info-row .value {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
